import { IconsName } from '@fairfashion/design-system'

import { AuditItemDetails } from '../../pages/AuditItemDetails/audit-item-details.page'
import { AuditItems } from '../../pages/AuditItems/audit-items.page'
import { Dashboard } from '../../pages/Dashboard/dashboard.page'
import { Faq } from '../../pages/Faq'
import { MyCompany } from '../../pages/MyCompany/my-company.page'
import { OrderProduction } from '../../pages/OrderProduction/order-production.page'
import { OrderProductions } from '../../pages/OrderProductions/order-productions.page'
import { OriginInvoice } from '../../pages/OriginInvoice/origin-invoice.page'
import { OriginInvoiceView } from '../../pages/OriginInvoiceView/origin-invoice-view.page'
import { OriginItems } from '../../pages/OriginItems/origin-items.page'
import { ProductDetails } from '../../pages/ProductDetails/product-details.page'
import { Products } from '../../pages/Products/products.page'
import { Provider } from '../../pages/Provider/provider.page'
import { ProviderDashboard } from '../../pages/ProviderDashboard/provider-dashboard.page'
// import { ProviderInvoice } from '../../pages/ProviderInvoice/provider-invoice.page'
import { ProviderItems } from '../../pages/ProviderItems/provider-items.page'
import { Providers } from '../../pages/Providers/providers.page'
import { QRCode } from '../../pages/QRCode/qrcode.page'
import { QRCodeDetails } from '../../pages/QRCodeDetails/qrcode-details.page'
import { QRCodeEditStep } from '../../pages/QRCodeEditStep/qrcode-edit-step.page'
import { Report } from '../../pages/Report/report.page'
import { Reports } from '../../pages/Reports/reports.page'
import { FairfashionModule } from '../../sdk/user/user.types'

export type UserRole = 'fashion_company' | 'blockforce' | 'providers' | 'all'

export interface RouteItem {
  title: string
  icon: IconsName
  url?: string
  sidebar?: boolean
  permissions: UserRole[]
  module?: FairfashionModule
  element: JSX.Element
}

export const routes: RouteItem[] = [
  {
    title: 'Dashboard',
    icon: 'dashboard',
    url: '/dashboard',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <Dashboard />,
    module: 'traceability',
  },
  {
    title: 'Dashboard',
    icon: 'dashboard',
    url: '/dashboard',
    sidebar: true,
    permissions: ['providers'],
    element: <ProviderDashboard />,
  },
  {
    title: 'Minha Empresa',
    icon: 'building2',
    url: '/company',
    permissions: ['all'],
    element: <MyCompany />,
  },
  {
    title: 'Rastreabilidade',
    icon: 'route',
    url: '/origins',
    sidebar: true,
    permissions: ['providers'],
    element: <ProviderItems />,
  },
  {
    title: 'Rastreabilidade',
    icon: 'route',
    url: '/origins/:id',
    sidebar: false,
    permissions: ['all'],
    element: <OriginItems />,
  },
  {
    title: 'Auditoria',
    icon: 'file_search',
    url: '/audit',
    sidebar: true,
    permissions: ['providers'],
    element: <AuditItems />,
  },
  {
    title: 'Auditoria',
    icon: 'file_search',
    url: '/audit/:id',
    sidebar: false,
    permissions: ['providers'],
    element: <AuditItemDetails />,
  },
  {
    title: 'Produtos',
    icon: 'price_tag3',
    url: '/products',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <Products />,
  },
  {
    title: 'Meus fornecedores',
    icon: 'store3',
    url: '/providers',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <Providers />,
  },
  {
    title: 'Fornecedor',
    icon: 'user',
    url: '/providers/:providerTaxId',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <Provider />,
  },
  {
    title: 'Produto',
    icon: 'barcode_box',
    url: '/products/:code',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <ProductDetails />,
  },
  {
    title: 'Relatórios',
    icon: 'file_chart',
    url: '/reports',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <Reports />,
    module: 'traceability',
  },

  {
    title: 'Notas Fiscais',
    icon: 'receipt',
    url: '/invoices',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <OriginInvoice />,
  },
  {
    title: 'Notas Fiscais',
    icon: 'receipt',
    url: '/invoices/:providerTaxId?',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <OriginInvoice />,
  },
  {
    title: 'Detalhes',
    icon: 'receipt',
    url: '/invoices/:providerTaxId/:invoiceCode',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <OriginInvoiceView />,
  },
  {
    title: 'Processos Produtivos',
    icon: 'swap2',
    url: '/order-productions',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <OrderProductions />,
    module: 'production_process',
  },
  {
    title: 'Processo Produtivo',
    icon: 'swap2',
    url: '/order-productions/:code',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <OrderProduction />,
    module: 'production_process',
  },
  {
    title: 'Relatório',
    icon: 'file_chart',
    url: '/reports/:report',
    permissions: ['blockforce', 'fashion_company'],
    element: <Report />,
  },
  {
    title: 'QR Code',
    icon: 'qr_code',
    url: '/qrcode',
    sidebar: true,
    permissions: ['blockforce', 'fashion_company'],
    element: <QRCode />,
    module: 'qrcode',
  },
  {
    title: 'QR Code',
    icon: 'qr_code',
    url: '/qrcode/:code',
    sidebar: false,
    permissions: ['blockforce', 'fashion_company'],
    element: <QRCodeDetails />,
    module: 'qrcode',
  },
  {
    title: 'Editar Etapa',
    icon: 'edit',
    url: '/qrcode/:code/journey/:stepId',
    permissions: ['blockforce', 'fashion_company'],
    element: <QRCodeEditStep />,
    module: 'qrcode',
  },

  {
    title: 'FAQ',
    icon: 'question',
    url: '/faq',
    permissions: ['all'],
    element: <Faq />,
  },
]
